import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';
import * as defaults from '../../store-defaults';
import { mapSettings } from '@vue/components/google-maps/constants/mapSettings';

export default {
  namespaced: true,
  state: {
    appState: 'default',
    propertyMapState: 'default',
    initialized: false,
    errors: [],
    formErrors: {},
    zipcodes: [],
    queryString: '',
    searchType: 'for-sale',
    searchView: 'agent', // used on agent pages. values: agent - all
    locationChanging: false,
    mapView: -1,
    mapConfig: {
      ...mapSettings,
      center: {lat: 0, lng: 0},
      initialBounds: {}
    },
    mlsDisclaimers: {},
    selectedLocation: {},
    selectedMarket: {},
    selectedCounty: {},
    markers: [],
    manageType: '',
    properties: [],
    mls_photos: [],
    listings: [],
    highlightedProperty: {},
    savedPropertySearch: {
      id: '',
      title: ''
    },
    mlsDisclaimerText: '',
    mlsDisclaimersTextList: [],
    brokerageFootersList: [],
    mlsNames: [],
    mlsName: '',
    searchParams: {
      ss: '',
      page: 1,
      loc_cd: '',
      lat: '', // Initial Coords to Center the Map On
      lng: '', // Initial Coords to Center the Map 
      zoom: '', // initial map zoom
      location_txt: '',
      limit: '', // how many results the API should send back per page
      min_lat: '',
      max_lat: '',
      min_lng: '',
      max_lng: '',

      /* size */
      min_beds: '',
      max_beds: '',
      min_baths: '',
      max_baths: '',
      min_year_built: '',
            
      /* financials */
      min_asking_price: '',
      max_asking_price: '',
      min_rent_amt: '',
      max_rent_amt: '',
      min_gross_yield: '',
      max_gross_yield: '',
      min_net_yield: '',
      max_net_yield: '',
      min_monthly_rent: '',
      max_monthly_rent: '',
      min_expense_load: '',
      max_expense_load: '',
      min_hpa: '',
      max_hpa: '',

      /* size */
      min_sqft: '',
      max_sqft: '',
      min_lot_size: '',
      max_lot_size: '',
            
      match_type: 'i',
      order_by: '',
      order_dir: '',
      // leased_properties_only: false,
      section8: false,
            
      /* Interior */
      has_dining_area: false,
      has_high_ceilings: false,
      has_ceiling_fans: false,
      has_walk_in_closets: false,
      has_granite_countertops: false,
      has_satellite_tv: false,
      has_cable_ready: false,
      has_fireplace: false,
      has_storage: false,
      has_indoor_jacuzzi: false,
      has_views: false,

      // Flooring
      has_ceramic_tile: false,
      has_hardwood_floors: false,
      has_new_carpet: false,

      // Laundry
      has_washer: false,
      has_dryer: false,

      // Kitchen
      has_stainless_steel_appliances: false,
      has_eat_in_kitchen: false,
      has_oven_range: false,
      has_garbage_disposal: false,
      has_refrigerator: false,
      has_stove: false,
      has_dishwasher: false,
      has_microwave: false,

      // Heating / Cooling
      has_ac: false,
      has_central_heating: false,

      // Misc
      selected_zipcodes: [],

      // Added for Agent Sites 
      listingsType: 'for-sale',
      listingsView: 'agent',

      // Implemented by the Property Type Filter in the main search -- Values: SFR or Multi Family
      building_types: [],
      email_frequency: 'daily',
      radius: 50,

    },
    totalCnt: '',
    fieldGroups: {
      financials: [
        'min_net_yield',
        'max_net_yield',
        'min_monthly_rent',
        'max_monthly_rent',
        'min_expense_load',
        'max_expense_load',
        'min_hpa',
        'max_hpa',
      ],
      size: [
        'min_sqft',
        'max_sqft',
        'min_lot_size',
        'max_lot_size',
      ],
      interior: [
        'has_dining_area',
        'has_high_ceilings',
        'has_ceiling_fans',
        'has_walk_in_closets',
        'has_granite_countertops',
        'has_satellite_tv',
        'has_cable_ready',
        'has_fireplace',
        'has_storage',
        'has_indoor_jacuzzi',
      ],
      flooring: [
        'has_ceramic_tile',
        'has_hardwood_floors',
        'has_new_carpet',
      ],
      kitchen: [
        'has_stainless_steel_appliances',
        'has_eat_in_kitchen',
        'has_oven_range',
        'has_garbage_disposal',
        'has_refrigerator',
        'has_stove',
        'has_dishwasher',
        'has_microwave',
      ],
      laundry: [
        'has_dryer',
        'has_washer',
      ],
      heatingCooling: [
        'has_ac',
        'has_central_heating',
      ],
      other: [
        // 'leased_properties_only',
        'section8',
        'has_views',
      ],
    }
  },
  mutations,
  actions,
  getters
};